import React, { useState, useEffect } from "react";
import { Row as AntRow, Col as AntCol, Image, Descriptions, Watermark } from "antd";
import { Table, Row, Col, Container } from "react-bootstrap";
import Moment from "react-moment";
import Common from "./includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var SessionPaymentReceipt = function SessionPaymentReceipt(_ref) {
  var session = _ref.session,
    attender = _ref.attender,
    due = _ref.due,
    transaction = _ref.transaction;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(AntRow, {
      children: /*#__PURE__*/_jsx(AntCol, {
        children: /*#__PURE__*/_jsxs("div", {
          style: {
            textAlign: "center",
            borderBottom: "1px solid grey",
            padding: "10px"
          },
          children: [/*#__PURE__*/_jsx("h4", {
            children: /*#__PURE__*/_jsx("b", {
              children: "CABINET DE FORMATION ET DE METIERS"
            })
          }), /*#__PURE__*/_jsx("b", {
            style: {
              color: "#C16259"
            },
            children: "Formation - Accompagnement - Assistance - Conseil en gestion"
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("span", {
            children: "Tel:(+ 224) 629 84 60 60 / 662 48 34 34 ; Email : info@cfemguinee.net"
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("span", {
            children: "Adresse : Commune de Ratoma, kip\xE9-centre \xE9metteur en face de plaza diamant"
          })]
        })
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(AntRow, {
      children: [/*#__PURE__*/_jsxs(AntCol, {
        span: 6,
        style: {
          width: "30%",
          "float": "left"
        },
        children: [/*#__PURE__*/_jsx(Image, {
          preview: false,
          src: "/drawables/cfem-logo.png",
          width: "130px",
          style: {
            width: "130px"
          }
        }), /*#__PURE__*/_jsxs("h4", {
          children: ["Re\xE7u N\xBA: ", transaction]
        })]
      }), /*#__PURE__*/_jsxs(AntCol, {
        span: 12,
        offset: 6,
        style: {
          width: "50%",
          "float": "right"
        },
        children: [/*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx("b", {
            children: "Date:"
          }), " ", /*#__PURE__*/_jsx(Moment, {
            format: "DD/MM/YYYY H:m"
          })]
        }), /*#__PURE__*/_jsx("h4", {
          style: {
            textAlign: "center",
            marginTop: '40px',
            padding: '30px',
            border: "7px solid #C15A50 ",
            display: "block",
            backgroundColor: "#C1ACAA",
            color: "#C15A50"
          },
          children: /*#__PURE__*/_jsx("b", {
            children: attender.name
          })
        })]
      })]
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Watermark, {
      height: 60,
      width: 190,
      image: "/drawables/cfem-logo.png",
      children: [/*#__PURE__*/_jsxs(Table, {
        bordered: true,
        striped: true,
        responsive: true,
        style: {
          border: "1px solid #E0E0E0",
          borderCollapse: "collapse"
        },
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("td", {
              style: {
                border: "1px solid #E0E0E0",
                borderCollapse: "collapse"
              },
              children: "D\xE9signation"
            }), /*#__PURE__*/_jsx("td", {
              style: {
                border: "1px solid #E0E0E0",
                borderCollapse: "collapse"
              },
              children: "Montant"
            })]
          })
        }), /*#__PURE__*/_jsxs("tbody", {
          children: [/*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("td", {
              style: {
                border: "1px solid #E0E0E0",
                borderCollapse: "collapse"
              },
              children: session.label
            }), /*#__PURE__*/_jsx("td", {
              style: {
                border: "1px solid #E0E0E0",
                borderCollapse: "collapse"
              },
              children: session.price.toLocaleString("Fr")
            })]
          }), /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("td", {
              style: {
                border: "1px solid #E0E0E0",
                borderCollapse: "collapse"
              },
              children: "TOTAL"
            }), /*#__PURE__*/_jsx("td", {
              style: {
                border: "1px solid #E0E0E0",
                borderCollapse: "collapse"
              },
              children: session.price.toLocaleString("Fr")
            })]
          })]
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
    }), /*#__PURE__*/_jsxs("p", {
      children: ["Arr\xEAt\xE9 ce pr\xE9sent re\xE7u \xE0 ", session.price.toLocaleString("Fr"), " Franc Guin\xE9en"]
    }), /*#__PURE__*/_jsxs("span", {
      children: ["Reste \xE0 payer: ", due.toLocaleString('Fr'), " GNF"]
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsx(Col, {
        lg: 6,
        md: 6,
        style: {
          width: "48%",
          "float": "left"
        },
        children: /*#__PURE__*/_jsx("div", {
          style: {
            padding: "10px 10px 140px 10px",
            border: "1px solid grey",
            borderRadius: "4px"
          },
          children: "Le client"
        })
      }), /*#__PURE__*/_jsx(Col, {
        lg: 6,
        md: 6,
        style: {
          width: "48%",
          "float": "right"
        },
        children: /*#__PURE__*/_jsxs("div", {
          style: {
            padding: "10px 10px 140px 10px",
            border: "1px solid grey",
            borderRadius: "4px"
          },
          children: ["Pour CFEM (", "".concat(Common.currentUser.nom, " ").concat(Common.currentUser.prenom), ")"]
        })
      })]
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("p", {
      style: {
        clear: "both",
        padding: "90px 0 0 30px"
      },
      children: /*#__PURE__*/_jsx("b", {
        children: "Adresse: Conakry, KIPE, En Face du Plazza Diamond - Tel: 621 00 00 26/ 662 48 34 34"
      })
    })]
  });
};
export default SessionPaymentReceipt;